import React, { useContext, createContext, useEffect, useState } from "react";
import { EnglishStrings } from "../resources/strings/english-strings";
import { SwedishStrings } from "../resources/strings/swedish-strings";

export const AppDataContext = createContext({
  strings: EnglishStrings,
  currentLanguage: "",
  modalOpen: false,
  focus: true,
  setLanguage: (_value) => {
    return null;
  },
  setModalOpen: (_value) => {
    return null;
  },
});

export const AppDataProvider = (props) => {
  const defaultLang = "sw";
  const [language, setLanguage] = useState(defaultLang);
  const [modalOpen, setModalOpen] = useState(false);
  const [focus, setFocus] = useState(true);

  const initialize = async () => {
    setLanguage(localStorage.getItem("language") || defaultLang);
  };

  useEffect(() => {
    initialize();
  }, []);
  useEffect(() => {
    document.documentElement.setAttribute(
      "lang",
      language === "sw" ? "sv" : "en"
    );
  }, [language]);

  const strings = () => {
    switch (language) {
      case "en":
        return EnglishStrings;
      case "sw":
        return SwedishStrings;
      default:
        return EnglishStrings;
    }
  };

  return (
    <AppDataContext.Provider
      value={{
        strings: strings(),
        currentLanguage: language,
        setLanguage: (value) => {
          localStorage.setItem("language", value);
          setLanguage(value);
        },
        modalOpen: modalOpen,
        setModalOpen: (value) => {
          setModalOpen(value);
        },
        focus: focus,
        setFocus: (value) => {
          setFocus(value);
        },
      }}
    >
      {props.children}
    </AppDataContext.Provider>
  );
};

export const useAppData = () => useContext(AppDataContext);
